import SMService from "../../services/SMService";
import { saveBetsOfUser, saveEventMarketList, saveMarketList, saveSMBookData } from "../slices/SMSlice";
import store from "../store";


export function GetSMEventMarketList(marketId) {
    return new Promise((resolve, rejact) => {
        SMService.GetSMEventMarketListService(marketId).then((res) => {
            store.dispatch(saveEventMarketList(res.data))
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}

export function postSMEventSave(data) {
    return new Promise((resolve, rejact) => {
        SMService.postSMEventSaveService(data).then((res) => {
            console.log("postSMEventSave", res);

            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}

export function GetSMMarketList(isOpen) {
    return new Promise((resolve, rejact) => {
        SMService.GetSMMarketListService(isOpen).then((res) => {
            store.dispatch(saveMarketList(res.data))
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}

export function GetSMMBetsOfUser(marketId, uid) {
    return new Promise((resolve, rejact) => {
        SMService.GetSMMBetsOfUserService(marketId, uid).then((res) => {
            store.dispatch(saveBetsOfUser(res.data))
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}

export function setSMResult(data) {
    return new Promise((resolve, rejact) => {
        SMService.GetSMSetResultService(data).then((res) => {
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}

export function SetSMDeleteResult(marketId) {
    return new Promise((resolve, rejact) => {
        SMService.SetSMDeleteResultService(marketId).then((res) => {
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}
export function SetSMEventStatus(eventId) {
    return new Promise((resolve, rejact) => {
        SMService.SetSMEventStatusService(eventId).then((res) => {
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}
export function getSMBook(marketId) {
    return new Promise((resolve, rejact) => {
        SMService.getSMBookService(marketId).then((res) => {
            store.dispatch(saveSMBookData(res.data))
            resolve(res)
        }).catch((error) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('userDetails')
                window.location = '/login'
            }
        })
    })
}